import { ArrowBackOutlined, SaveOutlined } from "@mui/icons-material";
import {
  Box,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogProps,
  Stack,
} from "@mui/material";
import { XButton } from "../../mui-wrap/button/x-button";
import { XProgressButton } from "../../mui-wrap/button/x-progress-button";
type DialogFormProps = DialogProps & {
  onCancelBtnClicked?: () => void;
  onSaveBtnClick?: () => Promise<any>;
  onGoback?: () => void;
  saveBtnProps?: ButtonProps;
};
export const DialogForm = ({
  onCancelBtnClicked,
  onSaveBtnClick,
  onGoback,
  saveBtnProps,
  ...props
}: DialogFormProps) => {
  return (
    <Dialog
      {...props}
      fullWidth
      onClose={(event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason !== "backdropClick") {
          props?.onClose?.(event, reason);
        }
      }}
    >
      {props.children}
      <DialogActions sx={{ paddingLeft: "24px", paddingRight: "24px" }}>
        <Stack
          direction={"row"}
          spacing={1}
          alignItems={"center"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Box>
            {onGoback && (
              <XButton
                onClick={onGoback}
                startIcon={<ArrowBackOutlined></ArrowBackOutlined>}
              >
                Quay lại
              </XButton>
            )}
          </Box>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <XButton variant="text" onClick={onCancelBtnClicked}>
              Hủy
            </XButton>
            <XProgressButton
              {...saveBtnProps}
              variant="contained"
              asyncAction={async () => await onSaveBtnClick?.()}
              startIcon={<SaveOutlined />}
            >
              Lưu
            </XProgressButton>
          </Stack>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
